export interface IValueLabelKey {
  /**
   * The stable identity: what the API stores and what the patch payload carries. It never
   * changes with the language — `labelKey` is what the user reads (EN-5191).
   */
  value: string;
  labelKey: string;
}

/**
 * The keys are the `addPatient_*` ones rather than a second set of their own: Add patient and the
 * patient panel show the same words for the same values, and a translator should only ever be
 * asked for them once.
 */
export const sexOptions: Array<IValueLabelKey> = [
  { value: "m", labelKey: "addPatient_sexOptions_male" },
  { value: "f", labelKey: "addPatient_sexOptions_female" },
];

export const ethnicityOptions: Array<IValueLabelKey> = [
  { value: "white", labelKey: "addPatient_ethnicityOptions_white" },
  { value: "black", labelKey: "addPatient_ethnicityOptions_black" },
  { value: "asian", labelKey: "addPatient_ethnicityOptions_asian" },
  // `_other` on its own is i18next's plural suffix, so the key carries the word.
  { value: "other", labelKey: "addPatient_ethnicityOptions_otherEthnicity" },
];
